import type { ReactNode } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

export const FooterForegroundBox = ({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) => {
  return (
    <Col className="w-full flex-1 items-center justify-center gap-2 rounded-xl bg-od-bg-inverse-secondary p-4 md:flex-row md:justify-between">
      <Text as="p" className="shrink-0 text-label-sm">
        {title}
      </Text>
      {children}
    </Col>
  );
};
